module.exports = __webpack_public_path__ + "c.no2.8af2e7c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/c.no2.jpg
// module id = GUqW
// module chunks = 0